import { render, staticRenderFns } from "./chemReviewEtc.vue?vue&type=template&id=8b74c0ea"
import script from "./chemReviewEtc.vue?vue&type=script&lang=js"
export * from "./chemReviewEtc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b74c0ea')) {
      api.createRecord('8b74c0ea', component.options)
    } else {
      api.reload('8b74c0ea', component.options)
    }
    module.hot.accept("./chemReviewEtc.vue?vue&type=template&id=8b74c0ea", function () {
      api.rerender('8b74c0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/review/chemReviewEtc.vue"
export default component.exports